<template>
  <div>
    <div class="flex-none">
      <div v-if='posts.length' class="mx-auto w-full md:max-w-md flex-none flex flex-row py-1 topnav w-full justify-start mb-8">
        <img class="w-10 h-10 ml-1 mr-0" src='/img/PBC_logo.svg' />
        <div class="ml-4">
          <h3 class="text-white font-bold text-lg">Your Unclaimed Posts</h3>
          <h5 v-if='!loggedIn' class="text-gray-200 text-sm">You can claim these posts by logging in.</h5>
          <h5 else class="text-gray-200 text-sm">You can claim these posts by pressing claim.</h5>
        </div>
      </div>

      <div v-for='meme in posts' :key='meme.id' class="w-full flex flex-col mb-6">
        <div class="h-64">
          <pbc-post-play :id='meme.id'
                        :game='meme.game'
                        :start-pixi='true'
                        class="bg-gray-800 h-full w-full"
                        :fetch='true' />
        </div>
        <div class="effect w-full h-12 flex flex-row justify-between pointer-events-auto p-2 ">
          <button class="flex-none outline-button px-1" @click='open(meme)'>
            <share-variant />
          </button>
          <p class="grow text-white"><span class="mx-auto">{{meme.title}}</span></p>

          <apollo-mutation :mutation='claimAnonPostMutation'
                                           class='h-full'
                           :variables='{"id":user.id}'>
            <template v-slot="{mutate,loading,error}">
              <button class="flex-none text-white bg-green-600 border-white h-full outline-button w-24" @click='onClaim(meme, mutate)'>
                <div v-if='loading' class="spinner">&nbsp;</div>
                <span class="mx-auto">Claim</span>
              </button>
            </template>
          </apollo-mutation>
        </div>

      </div>
    </div>

    <auth-dialog v-if='promptUserLogin'
                 @close='onCloseAuthDialog'
                 :enable-guest='false'
                  :login-state='loginState'/>


  </div>
</template>
<script>
import { claimAnonPostMutation, deleteLocalMeme } from '@/gql/Queries.js';
import { mapState } from 'vuex';
import AuthDialog from '@ui/organisms/AuthDialog.vue';
import ShareVariant from '@icons/ShareVariant.vue';
import PbcPostPlay from '@ui/molecules/PbcPostPlay.vue';
import { cloneDeep } from 'lodash';
import { getLocalMemes } from '@/gql/Queries.js';
//import PbcPost from '@ui/molecules/PbcPost.vue';
export default {
  data() {
    return {
      promptUserLogin: false,
      loginState: 'redirect_localmemes', // we don't use JSON because I think there's a bug in amplify with weird encoded characters,
      claimAnonPostMutation,
      localMemes:[]
    }
  },
  components: {
    //PbcPost,
    PbcPostPlay,
    ShareVariant,
    AuthDialog
  },
  apollo: {
    localMemes: {
      query: getLocalMemes,
      client: 'localClient'
    }
  },
  methods:{
    onCloseAuthDialog() {
      this.promptUserLogin = false;
    },
    open(post) {
      this.$router.push({
        name:'play',
        params:{
          id:post.id
        }
      });
    },
    async onClaim(post, mutate) {
      if (this.loggedIn) {
        console.log('le claim');
        const lol = await mutate({variables:{id:post.id}});
        console.log('lol', lol);
        const lol2 = await this.$apollo.mutate({
          mutation:deleteLocalMeme,
          client: 'localClient',
          variables:{
            id: post.id
          }
        });
        console.log('lol2', lol2);

        console.log('refresh queries');
        setTimeout( () => {
          this.$emit("claimed");
        }, 1200);

        this.$ana.track({
          eventCategory: 'engagement',
          eventAction: 'claimedPost',
          extra: {
            id: post.id
          }
        });

      } else {
        this.promptUserLogin = true;
      }
    }
  },
  computed:{
    posts() {
      return (this.localMemes||[]).map( (post) => {
        const p = cloneDeep(post);
        p.replies = { total: 0 }
        p.type = "post";
        p.user = {
          id: "anonymous"
        }
        return p
      });
    },
    ...mapState(['loggedIn', 'user'])
  }
}
</script>
